<template>
    <div v-if="show" class="modal">
        <div class="modal-content max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <span class="close" @click="closeModal">&times;</span>
            <div class="lg:px-8">
                <div class="pb-4 w-full">
                    <h2 class="page-title">Зміна дати замовлення</h2>
                    <h3 class="page-subtitle mt-2">Резерв #{{ preOrder?.id }}</h3>
                </div>
                <div class="pb-8 w-full relative">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Нова дата:</label>

                    <div v-if="!currentDateData" class="flex justify-center items-center py-8">
                        <span class="text-gray-500">Завантаження календаря...</span>
                    </div>
                    <div v-else>
                        <div v-if="loadingCalendar" class="opacity-50 pointer-events-none">
                            <calendar
                                :calendarData="calendarData"
                                :currentDateData="currentDateData"
                                :default-disabled-days="{}"
                                :default-day="calendarDate"
                                @selectDate="changeDate"
                                @setDate="setMonth"
                            />
                        </div>
                        <calendar
                            v-else
                            :calendarData="calendarData"
                            :currentDateData="currentDateData"
                            :default-disabled-days="{}"
                            :default-day="calendarDate"
                            @selectDate="changeDate"
                            @setDate="setMonth"
                        />
                        <div v-if="form.errors.date" class="text-red-500 text-xs mt-2">{{ form.errors.date }}</div>
                        <div v-if="form.errors['date.0']" class="text-red-500 text-xs mt-2">{{ form.errors['date.0'] }}</div>
                    </div>
                </div>
                <div class="modal-booking-btn-wrapper mt-4">
                    <loading-button
                        class="btn-indigo btn-booking modal-booking-btn"
                        :loading="form.processing"
                        @click.prevent="saveDate"
                    >
                        Зберегти
                    </loading-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton";
import Calendar from "@/Component/Calendar";
import messages from "@/Constants/messages";
import {useToast} from 'vue-toastify';
import axios from "axios";
import {route} from "ziggy-js";

export default {
    name: "UpdateDateModal",
    components: { LoadingButton, Calendar },
    props: {
        show: Boolean,
        preOrder: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                date: [],
            }),
            calendarData: {},
            currentDateData: null,
            loadingCalendar: false,
            toast: null,
        };
    },
    computed: {
        calendarDate() {
            if (Array.isArray(this.form.date) && this.form.date.length > 0) {
                return this.form.date[0];
            }
            return this.preOrder ? this.preOrder.start_date : '';
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(newVal) {
                if (newVal && this.preOrder) {
                    this.form.date = [this.preOrder.start_date, this.preOrder.end_date];
                    const parts = this.preOrder.start_date.split('-');
                    const year = parts[0];
                    const month = parts[1];
                    this.fetchCalendarData(year, month);
                }
            }
        }
    },
    mounted() {
        this.toast = useToast();
    },
    methods: {
        route,
        fetchCalendarData(year, month) {
            if (!this.preOrder || !this.preOrder.point) return;

            this.loadingCalendar = true;
            axios.get(this.route('cabinet.point.calendar-data', this.preOrder.point.id), {
                params: { year, month }
            })
            .then(response => {
                this.calendarData = response.data.calendarData;
                this.currentDateData = response.data.currentDateData;
            })
            .catch(error => {
                console.error("Failed to fetch calendar data", error);
            })
            .finally(() => {
                this.loadingCalendar = false;
            });
        },
        changeDate(date) {
            // Frontend mimics multi-date behavior by passing the identical date
            this.form.date = [date, date];
        },
        setMonth(dateData) {
            this.fetchCalendarData(dateData.year, dateData.month);
        },
        closeModal() {
            this.$emit('update:show', false);
            this.form.reset();
            this.form.clearErrors();
        },
        saveDate() {
            this.form.put(this.route('cabinet.order.update-date', this.preOrder.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.toast.success('Дату замовлення успішно змінено');
                    this.closeModal();
                },
                onError: (errors) => {
                    const msg = Object.values(errors)[0] || 'Помилка зміни дати';
                    this.toast.error(msg);
                }
            });
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 50;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
